<template>
    <div class="year-tabs" role="tablist">
        <button v-for="y in years" :key="'yt-' + y.key" type="button" role="tab"
                class="year-tab" :class="{'active': y.key === value}" :aria-selected="y.key === value"
                @click="$emit('input', y.key)">
            <i :class="['fad', icon, 'mr-2']" v-if="icon"></i>
            <span class="label-text">{{ y.label }}</span>
            <span class="count" v-if="y.count !== undefined && y.count !== null">{{ y.count }}</span>
        </button>
    </div>
</template>

<script>
    /**
     * Horizontal year picker for record archives (completed courses, earned
     * certificates, conference records) and the Conference Center list.
     * One bar per page, the selected year's records render below it.
     * `years` is [{key, label, count?}], newest first; v-model is the key.
     * Pick the starting key with defaultYearKey() from utils/yearBuckets.
     */
    export default {
        name: 'YearTabs',
        props: {
            years: {type: Array, default: () => []},
            value: {type: [String, Number], default: null},
            icon: {type: String, default: 'fa-calendar'},
        }
    };
</script>

<style lang="scss" scoped>
    // Same shape as Bulma's .tabs on the blue: quiet blue-grey labels, the
    // active year in white with a lighter underline
    .year-tabs {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 1.5rem;
        border-bottom: 1px solid #4a5f78;
    }

    .year-tab {
        appearance: none;
        background: none;
        border: 0;
        border-bottom: 1px solid transparent;
        margin-bottom: -1px;
        padding: 0.5rem 1rem;
        display: inline-flex;
        align-items: center;
        color: #9faec2;
        font: inherit;
        font-size: 0.9rem;
        cursor: pointer;
        transition: color 120ms, border-color 120ms;

        i {
            color: inherit;
        }

        // The count sits in its own pill so it reads as a badge, not as
        // part of the year
        .count {
            margin-left: 0.5rem;
            padding: 0 0.45rem;
            min-width: 1.4rem;
            border-radius: 0.7rem;
            font-size: 0.75rem;
            line-height: 1.4rem;
            text-align: center;
            background: rgba(255, 255, 255, 0.12);
            color: #c6d1de;
        }

        &:hover {
            color: white;
            border-bottom-color: #6f8295;
        }

        &.active {
            color: white;
            border-bottom-color: #6f8295;

            .count {
                background: rgba(255, 255, 255, 0.9);
                color: #336699;
                font-weight: 600;
            }
        }
    }
</style>
